document.addEventListener('DOMContentLoaded', () => {
	const switchers = document.querySelectorAll('.js-langSwitch');

	switchers.forEach((switcher) => {
		const list = switcher.querySelector('.js-langSwitchList');
		const current = switcher.querySelector('.m-langSwitch__current');
		if (!list || !current) return;

		// Only enable click behavior on mobile/tablet
		function toggleClickMode() {
			if (window.innerWidth < 1100) {
				current.onclick = (e) => {
					e.stopPropagation();
					list.classList.toggle('-open');
				};

				document.addEventListener('click', (e) => {
					if (!switcher.contains(e.target)) {
						list.classList.remove('-open');
					}
				});
			} else {
				current.onclick = null;
				list.classList.remove('-open');
			}
		}

		toggleClickMode();
		window.addEventListener('resize', toggleClickMode);
	});
});
